import { ReactComponent as Image } from "assets/images/demonstration.svg";
import React, { SVGProps } from "react";
import styled from "styled-components";
import { DEMONSTRATION_ANIMATION_DURATION } from "configs/general";
import { useTranslation } from "react-i18next";

interface Props extends SVGProps<SVGSVGElement> {
  isOpen: boolean;
}

const DemoImage: React.FC<Props> = ({ isOpen, ...props }) => {
  const { t } = useTranslation();

  return (
    <StyledDemoImage
      role="img"
      aria-labelledby={
        t(
          "10690"
        ) /* Demonstração da solução de estacionamento para concessionárias */
      }
      title={
        t(
          "10690"
        ) /* Demonstração da solução de estacionamento para concessionárias */
      }
      $isOpen={isOpen}
      {...props}
    />
  );
};

export default DemoImage;

const StyledDemoImage = styled(Image)<{ $isOpen: boolean }>`
  overflow: visible;
  height: 100%;
  max-width: 100%;
  margin-top: auto;
  transform: translateY(${({ $isOpen }) => ($isOpen ? -10 : 0)}px);

  &,
  .top-bar,
  .middle-bar,
  .bottom-bar,
  .dot {
    transition: transform ${DEMONSTRATION_ANIMATION_DURATION};
  }

  .top-bar {
    transform: translateY(${({ $isOpen }) => ($isOpen ? -10 : 0)}px);
  }

  .middle-bar {
    transform: translateY(${({ $isOpen }) => ($isOpen ? -6 : 0)}px);
  }

  .bottom-bar {
    transform: translateY(${({ $isOpen }) => ($isOpen ? -3 : 0)}px);
  }

  .dot {
    transform: translateY(${({ $isOpen }) => ($isOpen ? -2 : 0)}px);
  }
` as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
    $isOpen: boolean;
  }
>;
